import attribute from '@/assets/images/attribute/attribute.png'

import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();
  const miningRules = [
    {
      title: '',
      textArr:
        [
          {
            text: t("rule.text1"),
            image: '',
          },
          {
            text: t("rule.text2"),
            image: '',
          },
          {
            text: t("rule.text3"),
            image: '',
          },
        ]
    },
  ]
  const rulesTextArr = [
    {
      title: t("rule.origins_of_card_power"),
      textArr:
        [
          {
            text: t("rule.text4"),
            image: '',
          },
          {
            text: t("rule.text5"),
            image: '',
          },
        ]
    },
    {
      title: t("coinsRecord.carda"),
      textArr:
        [
          {
            text: t("rule.text6"),
            image: '',
          },
          {
            text: t("rule.text7"),
            image: attribute,
          },
          {
            text: t("rule.text8"),
            image: '',
          },
        ]
    },
    {
      title: t("rule.title1"),
      textArr:
        [
          {
            text: t("rule.text9"),
            image: '',
          },
          {
            text: t("rule.text10"),
            image: '',
          },
          {
            text: t("rule.text11"),
            image: '',
          },
          {
            text: t("rule.text12"),
            image: '',
          },
        ]
    },
    {
      title: t("rule.title2"),
      textArr:
        [
          {
            text: t("rule.text13"),
            image: '',
          },
          {
            text: t("rule.text14"),
            image: '',
          },
          {
            text: t("rule.text15"),
            image: '',
          },
          {
            text: t("rule.text16"),
            image: '',
          },
        ]
    }
  ]
  const cardPkRulesTextArr = [
    {
      title: t("rule.title3"),
      textArr:
        [
          {
            text: t("rule.text17"),
            image: ""
          },
          {
            text: t("rule.text18"),
            image: ""
          },

          {
            text: t("rule.text19"),
            image: '',
          },
          {
            text: t("rule.text20"),
            image: '',
          },
          {
            text: t("rule.text21"),
            image: '',
          },
          {
            text: t("rule.text22"),
            image: '',
          },
          {
            text: t("rule.text23"),
            image: '',
          },
        ]
    },
    {
      title: t("rule.title2"),
      textArr:
        [
          {
            text: t("rule.text24"),
            image: ""
          },
          {
            text: t("rule.text25"),
            image: '',
          },
          {
            text: t("rule.text26"),
            image: '',
          },
          {
            text: t("rule.text27"),
            image: '',
          },
          {
            text: t("rule.text28"),
            image: '',
          },
        ]
    }
  ]
  const PK_RULES = [
    {
      title: t("rule.title4"),
      textArr:
        [
          {
            text: t("rule.text29"),
            image: '',
          },
          {
            text: t("rule.text30"),
            image: '',
          },
          {
            text: t("rule.text31"),
            image: '',
          },
          {
            text: t("rule.text32"),
            image: '',
          },
        ]
    },
    {
      title: t("rule.title5"),
      textArr:
        [
          {
            text: t("rule.text33"),
            image: '',
          },
          {
            text: t("rule.text34"),
            image: '',
          },
          {
            text: t("rule.text35"),
            image: '',
          },
          {
            text: t("rule.text36"),
            image: '',
          }

        ]
    },
    {
      title: t("rule.title6"),
      textArr:
        [
          {
            text: t("rule.text37"),
            image: '',
          },
          {
            text: t("rule.text38"),
            image: attribute,
          },
          {
            text: t("rule.text39"),
            image: '',
          },
          {
            text: t("rule.text40"),
            image: '',
          },
          {
            text: t("rule.text42"),
            image: '',
          }

        ]
    }
  ]
  const Battle_RULES = [
    {
      title: '',
      textArr:
        [
          {
            text: t("rule.text43"),
            image: '',
          },
          {
            text: t("rule.text44"),
            image: '',
          }
          , {
            text: t("rule.text45"),
            image: '',
          },
          {
            text: t("rule.text46"),
            image: '',
          },
          {
            text: t("rule.text47"),
            image: '',
          },
          {
            text: t("rule.text48"),
            image: '',
          },
          {
            text: t("rule.text49"),
            image: '',
          },
          {
            text: t("rule.text50"),
            image: '',
          },
          {
            text: t("rule.text51"),
            image: '',
          }


        ]
    }
  ]

  return {
    miningRules,
    rulesTextArr,
    cardPkRulesTextArr,
    PK_RULES,
    Battle_RULES
  }
}
